import * as React from "react"
import * as _ from "lodash"
import { IPatientAllergy } from "@curefit/ehr-common";
import IPatientVital from "../../models/IPatientVital"
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import {IPatientVitalResponse} from "../../models/IPatientVitalResponse"
import IVital from "../../models/staticData/IVital"
import AppLoader from "../../components/utils/AppLoader"
import {PatientVitalsEditorProps} from "../../components/patient/edit/PatientVitalsEditor"
import {PatientVitalsViewProps} from "../../components/patient/view/PatientVitalsView"
import IEditedBy from "../../models/IEditedBy";
import {PatientVitalsSummaryBarProps} from "../../components/patient/summary-bar/PatientVitalsSummaryBar";
import {AppMessages, SourceConstants} from "../../utils/AppConstants";
import ErrorContainer from "../ErrorContainer";
import ModelFactory from "../../models/ModelFactory";
import {EventNames} from "../../utils/EventTrackerConstants";

/**
 * Created by aditya on 25/02/18.
 */

export interface VitalEditMap {
    [s: string]: IPatientVital;
}

export interface VitalsEditViewContProps {
    appointmentId?: number,
    editedBy?: IEditedBy,
    userId: number,
    patientId: number,
    metricIds: number[],
    patientVitals: IPatientVitalResponse[],
    patientAllergies?: IPatientAllergy[],
    staticVitalList: IVital[],
    fetchPatientVitals?: (patientId: number, userId: number, metricIds: number[]) => any,
    savePatientVitals?: (patientId: number, patientVitals: IPatientVital[]) => any,
    fetchAllStaticData?: () => any,
    displayMode?: EditViewDisplayMode,
    showSummary?: boolean,
    showCallapseButton?: boolean
}


export interface VitalsEditViewContState {
    vitalEditMap: VitalEditMap,
    isPatientVitalsLoaded: LOADING_STATE,
    isStaticVitalsLoaded: LOADING_STATE,
    error: string,
    vitalsFetched: boolean
}

class TodaysVitalsEditViewCont extends React.Component<VitalsEditViewContProps, VitalsEditViewContState> {
    private loadStartTime: number = AppUtils.getCurrentTime()
    constructor(props: VitalsEditViewContProps) {
        super(props);
        this.state = {
            ...this.getStateFromProps(props),
            vitalsFetched: false
        };
    }

    componentDidMount() {
        if (_.isEmpty(this.props.staticVitalList)) {
            this.props.fetchAllStaticData();
        }
        if (!this.state.vitalsFetched && !_.isEmpty(this.props.patientVitals)) {
            this.setState({
                vitalsFetched: true
            })
        } else {
            this.props.fetchPatientVitals(this.props.patientId, this.props.userId, this.props.metricIds);
        }
    }

    componentWillReceiveProps(newProps: VitalsEditViewContProps) {
        this.setState(this.getStateFromProps(newProps));
    }

    componentDidUpdate(prevProps: VitalsEditViewContProps, prevState: VitalsEditViewContState) {
        if (!prevState.vitalsFetched && !this.state.vitalsFetched) {
            this.props.fetchPatientVitals(this.props.patientId, this.props.userId, this.props.metricIds);
            this.setState({
                vitalsFetched: true
            })
        }
    }

    getStateFromProps = (props: VitalsEditViewContProps) => {
        let isPatientVitalsLoaded = LOADING_STATE.NOT_INITIALIZED;
        let isStaticVitalsLoaded = LOADING_STATE.NOT_INITIALIZED;

        if (_.isEmpty(props.staticVitalList)) {
            // this.props.fetchAllStaticData();
            isStaticVitalsLoaded = LOADING_STATE.LOADING;
        } else {
            if (this.state?.isStaticVitalsLoaded !== LOADING_STATE.LOADED) {
                AppUtils.updatePageLoadEvent(EventNames.All_Vitals, "", this.loadStartTime)
            }
            isStaticVitalsLoaded = LOADING_STATE.LOADED;
        }

        return {
            isPatientVitalsLoaded: isPatientVitalsLoaded,
            isStaticVitalsLoaded: isStaticVitalsLoaded,
            vitalEditMap: {},
            error: ""
        }
    }

    updatePatientVitalEditMap = (vitalEditMap: VitalEditMap) => {
        this.setState({vitalEditMap: vitalEditMap});
    }

    savePatientVitals = () => {
        let updatedPatientVitalList: IPatientVital[] = [];
        let appointmentId = this.props.appointmentId ? this.props.appointmentId : null;
        let personId = this.props.editedBy !== undefined ? this.props.editedBy.id : null;
        let personType = this.props.editedBy !== undefined ? this.props.editedBy.role : null;
        for ( let key in this.state.vitalEditMap ) {
            updatedPatientVitalList.push({...this.state.vitalEditMap[key],
                                            lastEditedPersonId: parseInt(personId),
                                            personType: personType.toLowerCase(),
                                            isDeleted: false,
                                            patient: { id: this.props.patientId },
                                            source: SourceConstants.DOCSASPP,
                                            appointmentId });
        }
        if ( updatedPatientVitalList.length > 0 ) {
            let myInstance = this;
            this.setState({isPatientVitalsLoaded: LOADING_STATE.NOT_INITIALIZED, vitalEditMap: {}});
            this.props.savePatientVitals(this.props.patientId, updatedPatientVitalList).then(() => {
                myInstance.setState({isPatientVitalsLoaded: LOADING_STATE.LOADING});
                myInstance.props.fetchPatientVitals(myInstance.props.patientId, this.props.userId, this.props.metricIds).then(() => {
                    myInstance.setState({isPatientVitalsLoaded: LOADING_STATE.LOADED});
                })
            }).catch((err: any) => {
                this.setState({
                    error: err.message
                })
            }).finally(() => {
                myInstance.setState({isPatientVitalsLoaded: LOADING_STATE.LOADED});
            });
        }
    }

    fetchVitals = () => {
        this.props.fetchPatientVitals(this.props.patientId, this.props.userId, this.props.metricIds)
    }

    getVitalEditViewTemplateProps() {
        let patientVitalEditorProps: PatientVitalsEditorProps = {
            staticVitalList: this.props.staticVitalList,
            vitalEditMap: this.state.vitalEditMap,
            updateVitalEditMap: this.updatePatientVitalEditMap,
            patientVitals: this.props.patientVitals
        }
        let patientVitalViewProps: PatientVitalsSummaryBarProps = {
            patientVitals: this.props.patientVitals,
            patientAllergies: this.props.patientAllergies,
            fetchVitals: this.fetchVitals
        }
        return {"view": patientVitalViewProps, "edit": patientVitalEditorProps}
    }

    cancelActionHandler = () => {
        this.setState({vitalEditMap: {}});
    }

    clearErrorMessage = () => {
        this.setState({
            error: ""
        })
    }

    render() {
        let isAllVitalsDataLoaded =  this.state.vitalsFetched
            && this.state.isStaticVitalsLoaded === LOADING_STATE.LOADED;
        let showCollapseButton = this.props.showCallapseButton !== undefined ? this.props.showCallapseButton : true;
        let errorText = !_.isNull(this.state.error) ? this.state.error : AppMessages.VITALS_SAVE_ERROR;
        return (
            <div>
                {
                    this.state.error !== "" &&
                    <ErrorContainer errorText={errorText} errorCode={500} closeError={this.clearErrorMessage}/>
                }
                {
                    isAllVitalsDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Today's Vitals"} templateName={"todaysVitals"}
                                  lastEditedEpoch={AppUtils.getLastEditedEpochForVital(this.props.patientVitals)}
                                  templateProps={this.getVitalEditViewTemplateProps()}
                                  cancelActionHandler={this.cancelActionHandler}
                                  saveActionHandler={this.savePatientVitals}
                                  displayMode={this.props.displayMode}
                                  showSummary={this.props.showSummary}
                                  showCollapseButton={showCollapseButton}
                    />
                }
                {
                    !isAllVitalsDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default TodaysVitalsEditViewCont